import { render, staticRenderFns } from "./Add-Images.vue?vue&type=template&id=51149eaa&scoped=true"
import script from "./Add-Images.vue?vue&type=script&lang=js"
export * from "./Add-Images.vue?vue&type=script&lang=js"
import style0 from "./Add-Images.vue?vue&type=style&index=0&id=51149eaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51149eaa",
  null
  
)

export default component.exports